// extracted by mini-css-extract-plugin
module.exports = {"footer":"TermsConsentPopup_footer__3lXMq","footerButton":"TermsConsentPopup_footerButton__1e3LO"};